import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class FontService {
	constructor(private http: HttpClient) { }

	getFontAsBinary(url): Observable<string> {
		return new Observable<string>((observer) => {
			this.http.get(url, { responseType: 'blob' }).subscribe((res: Blob) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					if (typeof reader.result === 'string') {
						observer.next(reader.result);
						observer.complete();
					} else {
						observer.error('Error reading font data');
					}
				};
				reader.readAsBinaryString(res);
			}, (error) => {
				observer.error(error);
			});
		});
	}
}